import React, { useState, useEffect } from 'react';

const API = '';
const getHeaders = () => ({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token') || localStorage.getItem('nomokratia_token')}` });

const LEGAL_AREAS = [
  {id:'civil', name:'Αστικό Δίκαιο', icon:'⚖️'},
  {id:'criminal', name:'Ποινικό Δίκαιο', icon:'🔒'},
  {id:'administrative', name:'Διοικητικό Δίκαιο', icon:'🏛️'},
];

const OUTCOME_COLORS = {
  'Απορριφθείσα': {bg:'#FEE2E2',color:'#991B1B',bar:'#EF4444'},
  'Αναιρεθείσα': {bg:'#D1FAE5',color:'#065F46',bar:'#10B981'},
  'Δεκτή': {bg:'#DBEAFE',color:'#1E40AF',bar:'#3B82F6'},
  'Μερικώς Δεκτή': {bg:'#FEF3C7',color:'#92400E',bar:'#F59E0B'},
  'Παραπεμπτική': {bg:'#EDE9FE',color:'#5B21B6',bar:'#8B5CF6'},
  'Αθωωτική': {bg:'#D1FAE5',color:'#065F46',bar:'#34D399'},
  'Καταδικαστική': {bg:'#FEE2E2',color:'#991B1B',bar:'#F87171'},
};

const OUTCOME_LABELS = {rejected:'Απορριφθείσα',overturned:'Αναιρεθείσα',accepted:'Δεκτή',partial:'Μερικώς Δεκτή',referred:'Παραπεμπτική',acquitted:'Αθωωτική',convicted:'Καταδικαστική'};

const AIInsights = () => {
  const [stats, setStats] = useState(null);
  const [prediction, setPrediction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [legalArea, setLegalArea] = useState('civil');
  const [facts, setFacts] = useState('');
  const [articles, setArticles] = useState('');

  useEffect(() => {
    fetch(API + '/api/search/outcome-stats')
      .then(r => r.json()).then(setStats).catch(() => {});
  }, []);

  const handlePredict = async () => {
    if (!facts.trim()) return;
    setLoading(true); setPrediction(null);
    try {
      const r = await fetch(API + '/api/search/predict-outcome', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          legal_area: legalArea, facts: facts.trim(),
          articles: articles ? articles.split(',').map(a => a.trim()) : [],
        })
      });
      setPrediction(await r.json());
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  const cs = {
    card:{background:'#FFF',borderRadius:14,border:'1px solid #E2E8F0',padding:20,marginBottom:16},
    label:{fontSize:12,fontWeight:600,color:'#475569',marginBottom:4,display:'block'},
    input:{width:'100%',padding:'10px 14px',borderRadius:10,border:'1px solid #E2E8F0',fontSize:14,outline:'none',boxSizing:'border-box'},
  };

  return (
    <div style={{maxWidth:1000,margin:'0 auto'}}>
      <div style={{background:'linear-gradient(135deg,#1E293B,#0F172A)',borderRadius:16,padding:24,color:'#FFF',marginBottom:20}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div>
            <h2 style={{fontSize:22,fontWeight:800,margin:'0 0 6px'}}>🎯 AI Outcome Prediction</h2>
            <p style={{fontSize:14,color:'#94A3B8',margin:0}}>
              Πρόβλεψη έκβασης βάσει {stats ? stats.total_processed.toLocaleString() : '54.000'}+ πραγματικών δικαστικών αποφάσεων
            </p>
          </div>
        </div>
      </div>

      {stats && (
        <div style={{...cs.card, background:'#F8FAFC'}}>
          <div style={{fontSize:14,fontWeight:700,color:'#1E293B',marginBottom:12}}>
            📊 Στατιστικά — {stats.total_processed.toLocaleString()} Αποφάσεις Ανωτάτων Δικαστηρίων
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12}}>
            {Object.entries(stats.outcomes || {}).filter(([k]) => k !== 'unknown').sort((a,b) => b[1].total - a[1].total).slice(0,4).map(([key, data]) => {
              const label = OUTCOME_LABELS[key] || key;
              const pct = (data.total / stats.total_processed * 100).toFixed(1);
              const colors = OUTCOME_COLORS[label] || {bg:'#F1F5F9',color:'#475569'};
              return (
                <div key={key} style={{textAlign:'center',padding:14,borderRadius:10,background:colors.bg}}>
                  <div style={{fontSize:24,fontWeight:800,color:colors.color}}>{pct}%</div>
                  <div style={{fontSize:11,fontWeight:600,color:colors.color,marginTop:2}}>{label}</div>
                  <div style={{fontSize:10,color:colors.color,opacity:0.7}}>{data.total.toLocaleString()}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div style={cs.card}>
        <div style={{fontSize:15,fontWeight:700,color:'#1E293B',marginBottom:14}}>🔍 Πρόβλεψη Έκβασης Υπόθεσης</div>
        <div style={{marginBottom:12}}>
          <label style={cs.label}>Κλάδος Δικαίου</label>
          <div style={{display:'flex',gap:8}}>
            {LEGAL_AREAS.map(area => (
              <button key={area.id} onClick={() => setLegalArea(area.id)} style={{
                flex:1,padding:'10px 12px',borderRadius:10,
                border:'2px solid '+(legalArea===area.id?'#3B82F6':'#E2E8F0'),
                background:legalArea===area.id?'#EFF6FF':'#FFF',
                cursor:'pointer',fontSize:13,fontWeight:600,
                color:legalArea===area.id?'#1E40AF':'#475569',textAlign:'center',
              }}>
                <span style={{fontSize:20,display:'block',marginBottom:4}}>{area.icon}</span>
                {area.name}
              </button>
            ))}
          </div>
        </div>
        <div style={{marginBottom:12}}>
          <label style={cs.label}>Περιγραφή Υπόθεσης / Πραγματικά Περιστατικά *</label>
          <textarea value={facts} onChange={e => setFacts(e.target.value)}
            placeholder="π.χ. αποζημίωση τροχαίο ατύχημα, σωματική βλάβη, ηθική βλάβη, ΑΚ 914..."
            style={{...cs.input,height:80,resize:'none',fontFamily:'inherit'}} />
        </div>
        <div style={{marginBottom:16}}>
          <label style={cs.label}>Σχετικά Άρθρα (προαιρετικό, χωρισμένα με κόμμα)</label>
          <input value={articles} onChange={e => setArticles(e.target.value)}
            placeholder="π.χ. 914, 932, 281" style={cs.input} />
        </div>
        <button onClick={handlePredict} disabled={loading||!facts.trim()} style={{
          width:'100%',padding:14,borderRadius:12,
          background:loading?'#94A3B8':'linear-gradient(135deg,#1E293B,#334155)',
          color:'#FFF',fontSize:15,fontWeight:700,border:'none',cursor:loading?'wait':'pointer',
        }}>
          {loading ? '⏳ Ανάλυση σε εξέλιξη...' : '🎯 Πρόβλεψη Έκβασης'}
        </button>
      </div>

      {prediction && !prediction.error && (
        <div style={{...cs.card, border:'2px solid #3B82F6'}}>
          <div style={{fontSize:15,fontWeight:700,color:'#1E293B',marginBottom:16}}>
            📈 Αποτελέσματα Πρόβλεψης
            <span style={{fontSize:12,fontWeight:400,color:'#94A3B8',marginLeft:8}}>
              Βάσει {prediction.total_similar} παρόμοιων αποφάσεων
            </span>
          </div>
          <div style={{
            textAlign:'center',padding:24,borderRadius:14,marginBottom:16,
            background:(OUTCOME_COLORS[prediction.prediction_label]||{bg:'#F1F5F9'}).bg,
          }}>
            <div style={{fontSize:48,fontWeight:900,color:(OUTCOME_COLORS[prediction.prediction_label]||{color:'#475569'}).color}}>
              {prediction.confidence}%
            </div>
            <div style={{fontSize:18,fontWeight:700,color:(OUTCOME_COLORS[prediction.prediction_label]||{color:'#475569'}).color,marginTop:4}}>
              {prediction.prediction_label}
            </div>
            <div style={{fontSize:12,color:'#64748B',marginTop:4}}>Πιθανότερη έκβαση</div>
          </div>
          <div style={{marginBottom:16}}>
            <div style={{fontSize:13,fontWeight:600,color:'#475569',marginBottom:8}}>Κατανομή Πιθανοτήτων</div>
            {Object.entries(prediction.probability_labels||{}).sort((a,b) => b[1]-a[1]).map(([label, pct]) => {
              const colors = OUTCOME_COLORS[label]||{bg:'#F1F5F9',color:'#475569',bar:'#94A3B8'};
              return (
                <div key={label} style={{marginBottom:8}}>
                  <div style={{display:'flex',justifyContent:'space-between',fontSize:12,marginBottom:3}}>
                    <span style={{fontWeight:600,color:colors.color}}>{label}</span>
                    <span style={{fontWeight:700,color:colors.color}}>{pct}%</span>
                  </div>
                  <div style={{height:8,borderRadius:4,background:'#F1F5F9',overflow:'hidden'}}>
                    <div style={{height:'100%',width:pct+'%',borderRadius:4,background:colors.bar,transition:'width 0.5s'}} />
                  </div>
                </div>
              );
            })}
          </div>
          {prediction.similar_cases && prediction.similar_cases.length > 0 && (
            <div>
              <div style={{fontSize:13,fontWeight:600,color:'#475569',marginBottom:8}}>📚 Παρόμοιες Αποφάσεις</div>
              {prediction.similar_cases.slice(0,5).map((c,i) => {
                const outcomeLabel = OUTCOME_LABELS[c.outcome]||c.outcome;
                const colors = OUTCOME_COLORS[outcomeLabel]||{bg:'#F1F5F9',color:'#475569'};
                return (
                  <div key={i} style={{
                    display:'flex',justifyContent:'space-between',alignItems:'center',
                    padding:'10px 14px',borderRadius:8,background:'#F8FAFC',marginBottom:6,border:'1px solid #E2E8F0',
                  }}>
                    <div>
                      <div style={{fontSize:13,fontWeight:600,color:'#1E293B'}}>{c.decision_number||'Απόφαση'}</div>
                      <div style={{fontSize:11,color:'#64748B',marginTop:2}}>{(c.title||'').substring(0,80)}</div>
                    </div>
                    <span style={{fontSize:11,fontWeight:700,padding:'4px 10px',borderRadius:6,background:colors.bg,color:colors.color,whiteSpace:'nowrap'}}>
                      {outcomeLabel}
                    </span>
                  </div>
                );
              })}
            </div>
          )}
          <div style={{marginTop:16,padding:'10px 14px',background:'#FEF3C7',borderRadius:8,fontSize:11,color:'#92400E'}}>
            ⚠️ Η πρόβλεψη βασίζεται σε στατιστική ανάλυση {prediction.total_similar} παρόμοιων αποφάσεων και δεν υποκαθιστά νομική συμβουλή.
          </div>
        </div>
      )}

      {prediction && prediction.error && (
        <div style={{...cs.card,border:'2px solid #FCA5A5',background:'#FEF2F2'}}>
          <div style={{fontSize:14,color:'#991B1B'}}>❌ {prediction.error}</div>
          <div style={{fontSize:12,color:'#B91C1C',marginTop:4}}>Δοκιμάστε διαφορετικούς όρους αναζήτησης.</div>
        </div>
      )}
    </div>
  );
};

export default AIInsights;
